<!--mat-dialog-content class="custom-dialog-container">
  <div class="spinner-container" *ngIf="loading">
    <mat-spinner></mat-spinner>
  </div>
  <div *ngIf="!loading">
    <h2>Configuração D-PARA para {{data.instanceName}}</h2>
    <div class="header-config">     
      <div>
        <mat-checkbox [(ngModel)]="hasUpdate">Atualizar tabela com registro importado?</mat-checkbox>
      </div>
      <div>
        <mat-checkbox [(ngModel)]="isJSON">Importação de JSON por Endpoint</mat-checkbox>
      </div>
      <div *ngIf="isJSON">
        <mat-form-field class="example-full-width">
          <mat-label>Endpoint:</mat-label>
          <input matInput class="marginLeft endpoint" [(ngModel)]="url">
        </mat-form-field>
      </div>
      <div *ngIf="isJSON" class="tokenForm">
        <mat-form-field class="example-full-width">
          <mat-label>Token:</mat-label>
          <input matInput class="marginLeft endpoint token" [(ngModel)]="token">
        </mat-form-field>
        <button mat-raised-button color="primary" (click)="loadJsonFromEndpoint()" class="load-json-button">Buscar Informações</button>
      </div>          
    </div>
    <div *ngIf="isJSON">
      <h3>Mapeamento de Campos JSON</h3>
      <mat-form-field aappearance="outline" class="search-field">
        <input matInput [(ngModel)]="searchField" placeholder="Pesquisar campo" (input)="filterFields()">
      </mat-form-field>
      <ng-container *ngIf="!showLoading">
        <table>
          <thead>
            <tr>
              <th>Nome do Campo JSON</th>
              <th>Coluna da Tabela</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let field of filteredFields">
              <td>{{ field.key }}</td>
              <td>

                <mat-form-field>
                  <mat-label>Coluna</mat-label>
                  <input type="text"
                         placeholder="Escolha uma coluna"
                         aria-label="Coluna"
                         matInput
                         [formControl]="myControl"
                         [matAutocomplete]="auto">
                  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="updateFieldMapping(field,$event)">
                    <mat-option *ngFor="let option of  filteredOptions | async" [value]="option.COLUMNNAME">
                      {{option.COLUMNNAME}}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
              </td>
            </tr>
          </tbody>
        </table>    
      </ng-container>
      <ng-container *ngIf="showLoading">     
        <mat-spinner></mat-spinner>
      </ng-container>
    </div>

    <div *ngIf="isJSON">
      <h3>JSON Personalizado</h3>
      <textarea class="textJson" matInput [(ngModel)]="customJson" rows="10" cols="50"></textarea>
      <button class="loadJsonPersonalized" mat-raised-button color="primary" (click)="parseCustomJson()">Carregar JSON Personalizado</button>
    </div>

    <div class="container">
      <button (click)="addTable()">Add Table</button>
    
      <div class="tables">
        <div *ngFor="let table of tables; let i = index">
          <h2>{{table.name}} <button (click)="removeTable(i)">-</button></h2>
          <div class="db-columns" cdkDropList [cdkDropListData]="table.columns" (cdkDropListDropped)="drop($event)">
            <div *ngFor="let column of table.columns" cdkDrag>{{column}}</div>
          </div>
        </div>
      </div>
    
      <div class="json">
        <h2>JSON</h2>
        <div class="json-keys" cdkDropList [cdkDropListData]="filteredFields" (cdkDropListDropped)="drop($event)">
          <div *ngFor="let key of filteredFields" cdkDrag>{{key.key}}</div>
        </div>
      </div>

      <div class="mappings">
        <h2>Mapeamentos</h2>
        <div *ngFor="let mapping of mappings; let i = index">
          {{mapping.jsonKey}} -> {{mapping.table}}.{{mapping.column}} <button (click)="removeMapping(i)">Remover</button>
        </div>
      </div>
    </div>
    
  </div>
</mat-dialog-content>

<mat-dialog-actions class="dialog-actions">
  <button mat-raised-button color="warn" mat-dialog-close>CANCELAR</button>
 
</mat-dialog-actions-->

<mat-dialog-content class="custom-dialog-container">
  
<div class="container">
  <div class="json-keys">
    <h2>JSON</h2>
    <div class="json-key" *ngFor="let key of jsonKeys">
      <div class="key-row" cdkDrag [cdkDragData]="key" (cdkDragEnded)="drop($event, key)">
        <span>{{key.name}}</span>
        <div class="dpara-column" cdkDropList [id]="'json-' + key.name" (cdkDropListDropped)="drop($event, key)">
          <input type="text" [(ngModel)]="key.mapping" readonly>
        </div>
      </div>
    </div>
  </div>
  <div class="table-cards">
    <button mat-raised-button color="primary">Add Table</button>
    <mat-accordion>
      <mat-expansion-panel *ngFor="let table of tables">
        <mat-expansion-panel-header>
          <mat-panel-title>
            {{table.name}}
          </mat-panel-title>
          <mat-panel-description>
            
          </mat-panel-description>
        </mat-expansion-panel-header>
        <div class="card-list" cdkDropList [cdkDropListData]="table.columns" [id]="'table-' + table.name" (cdkDropListDropped)="drop($event, table)">
          <div class="card" *ngFor="let column of table.columns" cdkDrag [cdkDragData]="column" (cdkDragEnded)="drop($event, column)">
            {{column}}
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</div>

  
  
  
  
  
  
  

  
  
</mat-dialog-content>

<mat-dialog-actions class="dialog-actions">
  <button mat-raised-button color="warn" mat-dialog-close>CANCELAR</button>
  <button mat-raised-button color="primary" [mat-dialog-close]="{
    columns: columns,
    hasHeader: hasHeader,
    hasUpdate: hasUpdate,
    headerLineNumber: headerLineNumber
  }" cdkFocusInitial>OK</button>
</mat-dialog-actions>